import {Community} from './community';
export class Builder {
  id: string;
  name: string;
  code: string;
  directory: string;
  communities: Community[];

  // constructor(public name: string,
  //             public code: string,
  //             public directory: string,
  //             public communities: Community[]) {}


  constructor(public data: any) {
    const j: JSON = data;

    this.id = j['id'];
    this.name = j['name'];
    this.directory = j['builder_directory'];
    this.communities = [];
    for (const c of j['communities']) {
      const community: Community = new Community(c);
      community.builderDirectory = this.directory;
      this.communities.push(community);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/builder.ts